/**
 * bookmarks — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {A4, tagline, chips, type ToilePack} from './data'

export const bookmarksPack: ToilePack = {
    slug: 'bookmarks',
    category: 'bookmarks',
    name: 'Bookmarks',
    tagline: tagline('sheets', 'motifs', 'styles'),
    chips: chips('motifs', 'styles'),
    ratio: A4,
    readings: [
        {key: 'flowers', label: 'Pressed flowers', subject: 'flattened pansies, ferns, cow parsley and grasses'},
        {key: 'celestial', label: 'Celestial', subject: 'moon phases, constellations, a sun face and stars'},
        {key: 'books', label: 'Stack of books', subject: 'leaning hardbacks, a ribbon, glasses and a cup'},
    ],
    styles: [
        {key: 'watercolor', label: 'Watercolor', style: 'transparent washes bleeding into the paper', palette: 'delicate and pale on cream', framing: 'four bookmarks, cut lines, punched holes'},
        {key: 'goldline', label: 'Gold on dark', style: 'thin metallic gold linework, no fills', palette: 'gold on deep navy', framing: 'four bookmarks, cut lines, punched holes'},
        {key: 'engraved', label: 'Engraved', style: 'dense fine hatching and stipple', palette: 'sepia ink on aged paper', framing: 'four bookmarks, cut lines, punched holes'},
    ],
    directions: ['a cat and yarn instead', 'in forest greens', 'with a quote line'],
}
